"use client"

import React, { useState, useEffect, useContext } from "react"
import { TableDownloadContext } from "../../Contexts/TableDownloadContext"
import moment from "moment"
import "../MainMenu.css"
import ExportPopup from "../../Components/ExportPopup"
import {
  vcinvestorProfileExportData,
  vcinvestorbackedIPOExportData,
  vcinvestorAngelInvestmentExportData,
  vcinvestorexitExportData,
  vcinvestorincubationExportData,
} from "../../Components/ExportPopup/ExportData"
import { exportInvestorExcel } from "../../Config/config"
import { TableDataContext } from "../../Contexts/TableDataContext"
import { PeFilterContext } from "../../Contexts/PeFilterContext"
import Constants from "../../Constants"
import { UserContext } from "../../Contexts/UserContext"
import { useLocation } from "react-router-dom"
import { ExportDirectoryExcel } from "../ExportPopup/DirectoryExport"
import DownloadTrigger from "../ExportPopup/DownloadTrigger"

function MainMenu(props) {
  const titleMap = {
    vcinvestor: "VC Investors VC Investment - Venture Intelligence",
    exits_vc: "VC Investors VC Exits - Venture Intelligence",
    ma_vc: "VC Investors Exits Via M&A (VC) - Venture Intelligence",
    public_vc: "VC Investors Exits Via Public Market (VC) - Venture Intelligence",
    vcbackedipo: "VC Investors VC Backed IPOs - Venture Intelligence",
    angel: "VC Investors Angel Investments - Venture Intelligence",
    incubation: "VC Investors Incubation - Venture Intelligence",
  }

  document.title = titleMap[props.menu] || "Venture Intelligence"

  const { save, setSave, showMonthPicker, refineSearchFilters, groupId, isMobile, setOpen, open, setIsMobile } =
    useContext(PeFilterContext)
  const { activeTabDeal, setActiveTabDeal, setCurrentPage, globalSearchResult } = useContext(TableDataContext)
  const { handleDownloadExcel } = useContext(TableDownloadContext)
  const [openTab, setOpenTab] = React.useState(1)
  const [showPopup, setShowPopup] = useState(false)
  const [date, setDate] = useState([
    moment().startOf("month").subtract(12, "months").format("YYYY-MM-DD"),
    moment().endOf("month").format("YYYY-MM-DD"),
  ])

  const { isStudent, isDirectoryUser, isTrialExport } = useContext(UserContext)

  const savedList = () => {
    setSave(!save)
  }

  useEffect(() => {
    setOpenTab(props.active)
  }, [openTab])

  useEffect(() => {
    if (window.innerWidth < 800) {
      // setOpen(true)
      setIsMobile(true)
    }
  }, [])

  const download = () => {
    handleDownloadExcel()
  }

  const { pathname } = useLocation()

  const isFromGlobalSearch = () => (refineSearchFilters[pathname]?.globalSearch?.length > 0 ? true : false)

  const category =
    props.menu === "investor"
      ? "pevc_count"
      : props.menu === "pevcExit"
        ? "exit_count"
        : props.menu === "backedipo"
          ? "ipo_count"
          : props.menu === "angel"
            ? "angel_count"
            : props.menu === "incubation"
              ? "incubation_count"
              : ""

  console.log(props.menu, "catee")

  return (
    <div className="pl-3 pr-4 lg:pr-4 md:pr-5">
      <div className="scrollbar rounded">
        <div className="px-2 md:px-3 rounded-[6px] rounded-b-none bg-white block lg:flex flex-row justify-between shadow-[0_2px_6px_0_rgba(0,0,0,0.08)]">
          <div className="flex flex-row  space-x-5 overflow-x-auto scrollbar-remove">
              <div></div>
            </div>
          <div
            className={
              "md:flex justify-between items-center px-3 lg:px-2 py-2 space-x-4 " + (showMonthPicker != 0 ? "" : "flex")
            }
          >
            <div className={showMonthPicker != 0 ? "hidden md:flex space-x-3" : "flex space-x-3"}>
              {isTrialExport == "false" || isStudent == "true" ? (
                <></>
              ) : (
                <>
                  <button>
                    <DownloadTrigger onClick={() => setShowPopup(!showPopup)} />
                    {showPopup && (
                      <div>
                        {isDirectoryUser ? (
                          <ExportDirectoryExcel
                            modules="investor"
                            url={exportInvestorExcel}
                            fileName={props.exportFileName}
                            module_type={props.primaryTypeMasterId === Constants.primaryMasterIds.peId ? "pe" : "vc"}
                            exportOptions={
                              props.menu === "vcinvestor"
                                ? vcinvestorProfileExportData
                                : props.menu === "vcbackedipo"
                                  ? vcinvestorbackedIPOExportData
                                  : props.menu === "angel"
                                    ? vcinvestorAngelInvestmentExportData
                                    : props.menu === "incubation"
                                      ? vcinvestorincubationExportData
                                      : vcinvestorexitExportData
                            }
                            type={
                              props.menu === "vcinvestor"
                                ? "vc_investment"
                                : props.menu === "vcbackedipo"
                                  ? "vcipo"
                                  : props.menu === "angel"
                                    ? "angel"
                                    : props.menu === "incubation"
                                      ? "incubation"
                                      : props.menu === "ma_vc"
                                        ? "vc_ma_exit"
                                        : props.menu === "public_vc"
                                          ? "vc_pm_exit"
                                          : "vc_exit"
                            }
                            onClose={() => setShowPopup(false)}
                          />
                        ) : (
                          <ExportPopup
                            onClose={() => setShowPopup(false)}
                            modules="investor"
                            fileName={props.exportFileName}
                            url={exportInvestorExcel}
                            module_type={props.primaryTypeMasterId === Constants.primaryMasterIds.vcId ? "vc" : "pe"}
                            exportOptions={
                              props.menu === "vcinvestor"
                                ? vcinvestorProfileExportData
                                : props.menu === "vcbackedipo"
                                  ? vcinvestorbackedIPOExportData
                                  : props.menu === "angel"
                                    ? vcinvestorAngelInvestmentExportData
                                    : props.menu === "incubation"
                                      ? vcinvestorincubationExportData
                                      : vcinvestorexitExportData
                            }
                            type={
                              props.menu === "vcinvestor"
                                ? "vc_investment"
                                : props.menu === "vcbackedipo"
                                  ? "vcipo"
                                  : props.menu === "angel"
                                    ? "angel"
                                    : props.menu === "incubation"
                                      ? "incubation"
                                      : props.menu === "ma_vc"
                                        ? "vc_ma_exit"
                                        : props.menu === "public_vc"
                                          ? "vc_pm_exit"
                                          : "vc_exit"
                            }
                          />
                        )}
                      </div>
                    )}
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default MainMenu
